__webpack_require__.p = "https://firebase-beautifulslides-static-assets.cdn.beautiful.ai/bundle/";